<!-- MFITTのサルーン予約の変更で、サルーンが存在しない列車を選んだ場合 -->
<template>
  <ItemDialog ref="notExistSaloon" image-type="alert">
    <template #content-area>
      <p class="text-center">
        この列車にサルーンはありません。<br />
        他の列車を選択してください。
      </p>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogNotExistSaloon",
  props: {
    closeButtonClicked: {
      type: Function,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const notExistSaloon = ref(null);

    const openDialog = () => {
      notExistSaloon.value.open();
    };

    const closeDialog = () => {
      if (props.closeButtonClicked == null) {
        notExistSaloon.value.close();
      } else {
        props.closeButtonClicked();
      }
    };

    return {
      notExistSaloon,
      props,
      openDialog,
      closeDialog,
    };
  },
};
</script>
